<template>
  <div
    class="full-size"
    :class="{ containerWidth: maxContainer, isAction }"
    ref="fullSizeRef"
  >
    <div class="full-size__header">
      <slot name="header"> </slot>
    </div>
    <slot> </slot>
  </div>
</template>

<script setup lang="ts">
import { useBaseLayout } from "@/stores/baseLayout";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";

const props = defineProps<{
  maxContainer?: boolean;
  isAction?: boolean;
}>();

const baseLayoutStore = useBaseLayout();
const fullSizeRef = ref<HTMLElement | null>(null);
const observer = ref<ResizeObserver | null>(null);

const updateFullSizeWidth = () => {
  if (fullSizeRef.value) {
    baseLayoutStore.fullSizeWidth = fullSizeRef.value.offsetWidth || 0;
  }
};

watch(
  () => props.maxContainer,
  () => {
    baseLayoutStore.currentPageWithMaxContainer = props.maxContainer;
  },
  { deep: true, immediate: true },
);

onMounted(() => {
  if (fullSizeRef.value) {
    observer.value = new ResizeObserver(updateFullSizeWidth);
    observer.value.observe(fullSizeRef.value);
    updateFullSizeWidth();
  }
});

onBeforeUnmount(() => {
  if (observer.value) {
    const baseContainer = fullSizeRef.value;
    if (baseContainer) {
      observer.value.unobserve(baseContainer);
    }
    observer.value.disconnect();
  }
});
</script>

<style scoped lang="scss">
.containerWidth {
  max-width: 1100px;
  margin: 0 auto;
}
.isAction {
  background: var(--color-bg-container);
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 15px;
  justify-content: center;
  display: flex;
  z-index: 2;

  .full-size__header {
    display: none;
  }
}
</style>
